import {encodeQueryString, encodeSearchOrderString} from './search-order-parser';
import {buildFacetFilterString} from './url/facet-filter-parser';
import {ReduxFacetGroup, ReduxSelectedFacetValuesByFieldName} from '../facets/facetTypes';
import {TabType} from './search-types';
import {encodeTab} from './url/tab-type-parse';

function buildUri(queryParameters: string[]): string {
    const filteredParams = queryParameters.filter(p => p !== '');
    if (filteredParams.length === 0) {
        return '';
    }
    return '?' + filteredParams.join('&');
}

export function buildEncodedUrlPath(route: string, searchExpression: string, sortField: string,
                                    facetFilter: ReduxSelectedFacetValuesByFieldName, facetGroup: ReduxFacetGroup,
                                    openTab?: TabType
): string {
    const searchOrderString = encodeSearchOrderString(sortField);
    const queryString = encodeQueryString(searchExpression.trim());
    const facetFilterString = buildFacetFilterString(facetFilter, facetGroup);
    const tabString = encodeTab(openTab);
    const routeString = route ? '/' + route : '';
    return routeString + buildUri([queryString, searchOrderString, facetFilterString, tabString]);
}
